module.exports = __webpack_public_path__ + "img/mensetu.a8a84936.jpg";